import {
  borderRadius,
  customScrollMinimal,
  SkeletonLoader,
} from '@toggle/design-system';
import styled from 'styled-components';

export const DropdownContainer = styled.div`
  width: 480px;
  max-height: 780px;
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  background-color: var(--background-soft);
  ${borderRadius.r2};
`;

export const ContentWrapper = styled.div`
  overflow-y: auto;
  min-height: 0;
  ${customScrollMinimal};
`;

export const StyledSkeletonLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '100%',
        borderRadius: '8px',
      },
    },
  ],
})`
  height: 90px;
  padding: 0 16px 16px 16px;
`;

export const PaginationLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '60px',
        borderRadius: '8px',
      },
    },
  ],
})`
  padding: 12px 20px;
`;
